var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClusterStops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23442 17.8482C2.74554 17.6455 2.35449 17.2545 2.15176 16.7656L2.61362 16.574C2.54057 16.3979 2.5 16.2043 2.5 16V15H2V13H2.5V11H2V9H2.5V7H2V5H2.5V4C2.5 3.79569 2.54057 3.60212 2.61362 3.42595L2.15176 3.23442C2.35449 2.74554 2.74554 2.35449 3.23442 2.15176L3.42595 2.61362C3.60212 2.54057 3.79569 2.5 4 2.5H5V2H7V2.5H9V2H11V2.5H13V2H15V2.5H16C16.2043 2.5 16.3979 2.54057 16.574 2.61362L16.7656 2.15176C17.2545 2.35449 17.6455 2.74554 17.8482 3.23442L17.3864 3.42595C17.4594 3.60212 17.5 3.79569 17.5 4V5H18V7H17.5V9H18V11H17.5V13H18V15H17.5V16C17.5 16.2043 17.4594 16.3979 17.3864 16.574L17.8482 16.7656C17.6455 17.2545 17.2545 17.6455 16.7656 17.8482L16.574 17.3864C16.3979 17.4594 16.2043 17.5 16 17.5H15V18H13V17.5H11V18H9V17.5H7V18H5V17.5H4C3.79569 17.5 3.60212 17.4594 3.42595 17.3864L3.23442 17.8482Z",
    stroke: "#6E7882",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C5.5 5.72386 5.72386 5.5 6 5.5H8.5C8.77614 5.5 9 5.72386 9 6V8.5C9 8.77614 8.77614 9 8.5 9H6C5.72386 9 5.5 8.77614 5.5 8.5V6Z",
    stroke: "#6E7882"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 5.72386 11.2239 5.5 11.5 5.5H14C14.2761 5.5 14.5 5.72386 14.5 6V8.5C14.5 8.77614 14.2761 9 14 9H11.5C11.2239 9 11 8.77614 11 8.5V6Z",
    stroke: "#6E7882"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5C5.5 11.2239 5.72386 11 6 11H8.5C8.77614 11 9 11.2239 9 11.5V14C9 14.2761 8.77614 14.5 8.5 14.5H6C5.72386 14.5 5.5 14.2761 5.5 14V11.5Z",
    stroke: "#6E7882"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5C11 11.2239 11.2239 11 11.5 11H14C14.2761 11 14.5 11.2239 14.5 11.5V14C14.5 14.2761 14.2761 14.5 14 14.5H11.5C11.2239 14.5 11 14.2761 11 14V11.5Z",
    stroke: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClusterStops);
export default __webpack_public_path__ + "static/media/icon-cluster-stops.234c8e620878821dcab0f0c0c46ecae1.svg";
export { ForwardRef as ReactComponent };